import React from 'react'
import PropTypes from 'prop-types'
import globalConfig from '../../config/globalConfig'
import { Fab, Menu, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import Logo from '../inumet/logo/LogoM'

import styles from './MenuFabIcons.module.css'

function MenuFabIcons({
    conLogoInumet,
    buttonIcons,
    buttonCaptions,
    buttonLinks,
    buttonsOnClick,
    mobileMode,
    visible,
}) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const fabButtons = []
    if (conLogoInumet)
        fabButtons.push(
            <Fab
                className={mobileMode ? styles.mobileItemMenu : ''}
                key={0}
                variant="extended"
                size="medium"
                color="primary"
                onClick={() => {
                    window.location.replace(globalConfig.PORTAL_INUMET)
                }}
            >
                <Logo
                    pathPrefix={globalConfig.URL_BASE_IMAGENES}
                    mr={3}
                    width={120}
                    completoTranspBlanco
                />
            </Fab>
        )

    for (let i = 0; i < buttonIcons.length; i++) {
        if (visible[i]) {
            fabButtons.push(
                <a key={i + 1} href={buttonLinks[i]}>
                    <Fab
                        className={mobileMode ? styles.mobileItemMenu : ''}
                        variant="extended"
                        size="medium"
                        color="primary"
                        onClick={(e) => {
                            e.preventDefault()
                            if (buttonLinks[i]) {
                                window.location.href = buttonLinks[i]
                            }
                            if (buttonsOnClick[i]) {
                                buttonsOnClick[i]()
                            }
                            handleClose()
                        }}
                    >
                        {buttonIcons[i]}
                        {buttonCaptions[i]}
                    </Fab>
                </a>
            )
        }
    }

    return mobileMode ? (
        <div className={styles.containerMobileDevices}>
            <IconButton
                variant="contained"
                onClick={handleClick}
                color="primary"
                size="large"
                sx={{
                    color: 'white',
                    backgroundColor: '#004b87', // Azul oscuro
                    '&:hover': {
                        backgroundColor: 'primary.dark',
                    },
                }}
                aria-controls={open ? 'mobile-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <MenuIcon />
            </IconButton>
            <Menu
                id="mobile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div className={styles.mobileMenuContent}>{fabButtons}</div>
            </Menu>
        </div>
    ) : (
        <div className={styles.containerLgDevices}>{fabButtons}</div>
    )
}

MenuFabIcons.propTypes = {
    mobileMode: PropTypes.bool,
    conLogoInumet: PropTypes.bool,
    buttonIcons: PropTypes.array,
    buttonCaptions: PropTypes.array,
    buttonLinks: PropTypes.array,
    buttonsOnClick: PropTypes.array,
    visible: PropTypes.array,
}

export { MenuFabIcons }
